import { useFormatter } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';
import { getLocalizedValue, getProductKeyFromCTType } from '@grandvisionhq/utils';

const useGetProductLinkFormatter = ()=>{
    const formatter = useFormatter();
    const { locale  } = useIntl();
    return (localizedSlug, sku, productType, additionalQueryParams)=>{
        const slug = typeof localizedSlug === 'string' ? localizedSlug : getLocalizedValue(localizedSlug, locale);
        const key = getProductKeyFromCTType(productType);
        const query = additionalQueryParams ? new URLSearchParams(additionalQueryParams) : undefined;
        const route = formatter({
            route: 'products.detail',
            params: {
                slug,
                sku,
                key
            },
            query
        });
        return typeof route === 'string' ? route : '#';
    };
};

export { useGetProductLinkFormatter };
//# sourceMappingURL=use-get-product-link-formatter.js.map
